<template>
    <a-modal title="提示"
             :width="550"
             :visible="visible"
             @cancel="$emit('cancel')"
             :maskClosable="false"
             :closable="false"
             :destroyOnClose="true"
    >
        <template slot="footer">
            <a-button type="primary" @click="onClose">直接跳转</a-button>
        </template>
        <a-card>
            <div style="margin-bottom: 15px;text-align: center;">
                <p>推送成功</p>
                <p style="color: red;font-size: 20px;font-weight: bold">{{count}}秒</p>
                <p>后即将跳转网站端查看发布公告详情</p>
            </div>
        </a-card>
    </a-modal>
</template>

<script>
  export default {
    name: 'ToWebAnnounceView',
    data () {
      return {
        count: 3,
        timer: null,
        visible: false,
        announceId: '',
        webAnnounceUrl: process.env.VUE_APP_WEB_DC_ANNOUNCE_URL
      }
    },
    destroyed () {
      if (this.timer) {
        clearInterval(this.timer)
      }
    },
    created () {
    },
    methods: {
      toWebView (id,webAnnounceUrl) {
        this.count = 3
        this.visible = true
        this.announceId = id
        this.webAnnounceUrl = webAnnounceUrl
        this.timer = setInterval(() => {
          if (this.count > 0) {
            this.count--
          } else {
            this.onClose()
          }
        }, 1000)
      },
      onClose () {
        this.visible = false
        clearInterval(this.timer)
        window.open( this.webAnnounceUrl+ this.announceId, '_blank')
      }
    },
  }
</script>

<style scoped>

</style>
